import React from "react";
import { Link } from "@mui/material";
import { Link as RouterLink } from 'react-router-dom';

const RegularLink = ({ to, children, target = "_self", fontColor = undefined, fontSize = undefined }) => {
    return (
        <Link
            component={RouterLink} 
            underline="hover"
            target={target}
            to={to}
            color={fontColor}
            fontSize={fontSize}
        >
            {children}
        </Link>
    );
}

export default RegularLink;
